import numeral from 'numeral'

let lineItemMixin = {
	methods: {
		format: function (value, format) {
			return numeral(value).format(format)
		}
	},
	computed: {
		isBulk: function () {
			return (this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].includes('**'))/* || (this.modelRecord && this.modelRecord['NDC Number'] && this.modelRecord['NDC Number'].currentValue)*/
		},
		hasFactor: function () {
			return this.record.fieldData['Danox_Dictionary::factor'] > 0
		},
		percentFill: function () {
			return this.format(this.record.fieldData['Percent Fill'], '0.00%')
		},
		showUnitConverter: function () {
			return this.record.fieldData['Danox_Dictionary_Final_Code::Avg. Tablet'] === 'Yes' || (this.record.fieldData['Danox_Dictionary_Final_Code::Package Size Density'] && this.record.fieldData['Danox_Dictionary_Final_Code::Package Size Density'].length > 0)
		},
		showStageUnitConverter: function () {
			return this.record.fieldData['Danox_Dictionary::HasStages']
			/*if (this.record.fieldData['Danox_Dictionary_Final_Code::Avg. Tablet Stages'] === 'Yes') {
				return true
			}
			let ndcFirstFive = this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].substring(0, 5);
			let labelerCodes = this.record.fieldData['Labeler Codes'];
			if (labelerCodes && labelerCodes.includes(ndcFirstFive)) {
				return true
			}*/
		},
	}
}

export default lineItemMixin